import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { getCampanias } from "../../../app/store/actions/campaniaActions";
import CampaniaDashboard from "./CampaniaDashboard";

const mapState = (state) => ({
  campanias: state.campaniaReducer.campanias,
  loadingCampanias: state.campaniaReducer.loadingCampanias,
  currentUser: state.auth.currentUser,
  loadingNotificacionSectorista:
    state.campaniaReducer.loadingNotificacionSectorista,
});

const actions = {
  getCampanias,
};

const CampaniaPage = ({
  getCampanias,
  campanias,
  loadingCampanias,
  currentUser,
  loadingNotificacionSectorista,
}) => {
  useEffect(() => {
    if(currentUser){
      getCampanias();
    }
  }, [getCampanias, currentUser?.username]);

  if (loadingCampanias)
    return <LoadingComponent content="Cargando campa&ntilde;as..." />;

  if (loadingNotificacionSectorista)
    return <LoadingComponent content="Enviando notificación a sectorista..." />;
  return <CampaniaDashboard campanias={campanias} />;
};

CampaniaPage.propTypes = {
  getCampanias: PropTypes.func.isRequired,
  campanias: PropTypes.array.isRequired,
  loadingCampanias: PropTypes.bool.isRequired,
  currentUser: PropTypes.object.isRequired,
};

export default connect(mapState, actions)(CampaniaPage);
